import Model from '../utils/Model'

class ProjectManageState {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'ProjectManageState'

export const IP_STATE = new ProjectManageState(1, '进行中', 'In Progress State')
export const CP_STATE = new ProjectManageState(2, '已完成', 'Completed State')
export const PROJECT_STATE = [IP_STATE, CP_STATE]

export const DF_STATE_DETAIL = new ProjectManageState(0, '草稿', 'Draft State')
export const IP_STATE_DETAIL = new ProjectManageState(1, '进行中', 'In Progress State')
export const CP_STATE_DETAIL = new ProjectManageState(2, '已完成', 'Completed State')

export const PROJECT_STATE_DETAIL = [DF_STATE_DETAIL, IP_STATE_DETAIL, CP_STATE_DETAIL]

export const UN_PAY_STATE = new ProjectManageState(0, '未付款', 'Unpaid')
export const PART_PAY_STATE = new ProjectManageState(1, '部分付款', 'Partial Payment')
export const FULL_PAY_STATE = new ProjectManageState(2, '全部付款', 'Full Payment')
export const AB_PAY_STATE = new ProjectManageState(3, '异常', 'Abnormal')

export const PROJECT_PAY_STATE = [UN_PAY_STATE, PART_PAY_STATE, FULL_PAY_STATE, AB_PAY_STATE]

export const UN_REC_STATE = new ProjectManageState(0, '未收款', 'Uncollected')
export const PART_REC_STATE = new ProjectManageState(1, '部分收款', 'Partial Collection')
export const FULL_REC_STATE = new ProjectManageState(2, '全部收款', 'Full Collection')
export const AB_REC_STATE = new ProjectManageState(3, '异常', 'Abnormal')

export const PROJECT_REC_STATE = [UN_REC_STATE, PART_REC_STATE, FULL_REC_STATE, AB_REC_STATE]
